function netraPreferMp4() {
  var isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
  var isIOSChrome = /CriOS/i.test(navigator.userAgent);
  var isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
  return isSafari || isIOSChrome || isIOS;
}

function netraActivateVideoSources(video, preferMp4) {
  video.querySelectorAll("source[data-src]").forEach(function (source) {
    var dataSrc = source.getAttribute("data-src");
    if (dataSrc) {
      source.setAttribute("src", dataSrc);
    }
  });
  if (preferMp4) {
    video.querySelectorAll('source[type="video/webm"]').forEach(function (source) {
      source.remove();
    });
  }
}

function netraSetupAutoplayVideo(video, options) {
  options = options || {};
  var onPlaying = options.onPlaying;
  var onFallback = options.onFallback;
  var confirmPlaying = options.confirmPlaying === true;
  var fallbackDelay = options.fallbackDelay || 600;
  var settled = false;
  var pendingTimer = null;
  var playingHandler = null;
  var retryTouch = null;
  var retryClick = null;
  var loadWaitCount = 0;
  var maxLoadWaits = 8;

  function clearPending() {
    if (pendingTimer) {
      clearTimeout(pendingTimer);
      pendingTimer = null;
    }
  }

  function clearPlayingHandler() {
    if (playingHandler) {
      video.removeEventListener("playing", playingHandler);
      playingHandler = null;
    }
  }

  function clearRetryListeners() {
    if (retryTouch) {
      document.removeEventListener("touchstart", retryTouch);
      retryTouch = null;
    }
    if (retryClick) {
      document.removeEventListener("click", retryClick);
      retryClick = null;
    }
  }

  function clearVideoFailed(videoEl) {
    if (!videoEl) {
      return;
    }
    videoEl.removeAttribute("data-video-failed");
  }

  function settlePlaying() {
    clearPending();
    clearPlayingHandler();
    clearRetryListeners();
    settled = true;
    clearVideoFailed(video);
    if (onPlaying) {
      onPlaying();
    }
  }

  function settleFallback() {
    if (!video.paused && video.readyState >= 2) {
      settlePlaying();
      return;
    }

    clearPending();
    clearPlayingHandler();
    settled = true;
    video.dataset.videoFailed = "true";
    video.pause();
    if (onFallback) {
      onFallback();
    }

    function recoverFromPlayback() {
      if (!video.paused && video.readyState >= 2) {
        video.removeEventListener("playing", recoverFromPlayback);
        video.removeEventListener("timeupdate", recoverFromPlayback);
        settled = false;
        settlePlaying();
      }
    }

    video.addEventListener("playing", recoverFromPlayback);
    video.addEventListener("timeupdate", recoverFromPlayback);
  }

  function scheduleFallbackCheck() {
    clearPending();
    pendingTimer = setTimeout(function () {
      if (!confirmPlaying && !video.paused && video.readyState >= 2) {
        settlePlaying();
        return;
      }

      if (!video.paused) {
        scheduleFallbackCheck();
        return;
      }

      if (video.error) {
        settleFallback();
        return;
      }

      if (video.readyState < 2) {
        loadWaitCount += 1;
        if (loadWaitCount < maxLoadWaits) {
          scheduleFallbackCheck();
          return;
        }
      }

      settleFallback();
    }, fallbackDelay);
  }

  function attemptPlay() {
    if (!video) {
      return;
    }
    clearPending();
    clearPlayingHandler();
    settled = false;
    if (!video.muted) {
      video.muted = true;
    }
    video.setAttribute("playsinline", "");

    if (video.readyState < 2) {
      video.addEventListener(
        "canplay",
        function onCanPlay() {
          video.removeEventListener("canplay", onCanPlay);
          attemptPlay();
        },
        { once: true }
      );
      scheduleFallbackCheck();
      return;
    }

    playingHandler = function () {
      settlePlaying();
    };
    video.addEventListener("playing", playingHandler);

    var playPromise;
    try {
      playPromise = video.play();
    } catch (err) {
      settleFallback();
      return;
    }

    if (playPromise && typeof playPromise.then === "function") {
      playPromise
        .then(function () {
          if (!confirmPlaying && !video.paused) {
            settlePlaying();
          }
        })
        .catch(function () {
          if (!video.error && video.readyState < 2) {
            scheduleFallbackCheck();
            return;
          }
          settleFallback();
        });
    }

    scheduleFallbackCheck();
  }

  video.addEventListener("error", settleFallback);

  if (options.retryOnInteraction !== false) {
    var retry = function () {
      if (video.dataset.videoFailed !== "true") {
        return;
      }
      clearVideoFailed(video);
      loadWaitCount = 0;
      settled = false;
      attemptPlay();
    };
    retryTouch = retry;
    retryClick = retry;
    document.addEventListener("touchstart", retryTouch, { passive: true });
    document.addEventListener("click", retryClick);
  }

  return attemptPlay;
}

window.netraSetupAutoplayVideo = netraSetupAutoplayVideo;
window.netraActivateVideoSources = netraActivateVideoSources;
window.netraPreferMp4 = netraPreferMp4;

function resumeFooterAutoplayVideos() {
  document.querySelectorAll(".footer-video video").forEach(function (video) {
    if (!video.dataset.loaded || video.dataset.loaded !== "true") {
      return;
    }

    var section = video.closest(".footer-video");

    if (video.dataset.videoFailed === "true") {
      video.removeAttribute("data-video-failed");
    }
    if (!video.muted) {
      video.muted = true;
    }
    video.setAttribute("playsinline", "");

    if (!video.paused && video.readyState >= 2) {
      if (section) {
        section.classList.add("is-video-ready");
      }
      return;
    }

    var playPromise = video.play();
    if (playPromise && typeof playPromise.then === "function") {
      playPromise
        .then(function () {
          if (section) {
            section.classList.add("is-video-ready");
          }
        })
        .catch(function () {});
    }
  });
}

window.resumeFooterAutoplayVideos = resumeFooterAutoplayVideos;

(function initFooterVideoLazyLoad() {
  var footerMediaBlocks = document.querySelectorAll(".footer-video__media");
  var footerVideos = document.querySelectorAll(".footer-video video");
  if ((!footerMediaBlocks.length && !footerVideos.length) || !window.netraSetupAutoplayVideo) {
    return;
  }

  function isMobileFooterViewport() {
    return window.matchMedia("(max-width: 767.9px)").matches || netraPreferMp4();
  }

  function loadFooterVideo(video) {
    if (!video || video.dataset.loaded === "true") {
      return;
    }

    var section = video.closest(".footer-video");
    var booted = false;
    var isMobileFooter = isMobileFooterViewport();

    function showPlaying() {
      if (section) {
        section.classList.add("is-video-ready");
      }
    }

    function showFallback() {
      if (section) {
        section.classList.remove("is-video-ready");
      }
    }

    function playOnUserGesture() {
      video.dataset.videoFailed = "";
      video.muted = true;
      video.playsInline = true;
      video.setAttribute("playsinline", "");
      var playPromise = video.play();
      if (playPromise && typeof playPromise.then === "function") {
        playPromise.then(showPlaying).catch(function () {});
      } else {
        showPlaying();
      }
    }

    video.addEventListener("playing", showPlaying);

    if (isMobileFooter) {
      var gestureTarget =
        video.closest(".footer-video__media") || video.closest(".footer-video__frame") || section;
      if (gestureTarget) {
        gestureTarget.addEventListener("touchstart", playOnUserGesture, { passive: true });
        gestureTarget.addEventListener("pointerdown", playOnUserGesture);
        gestureTarget.addEventListener("click", playOnUserGesture);
      }
    }

    function bootPlayback() {
      if (booted) {
        return;
      }
      booted = true;

      if (!video.paused && video.readyState >= 2) {
        showPlaying();
        return;
      }

      netraSetupAutoplayVideo(video, {
        onPlaying: showPlaying,
        onFallback: showFallback,
        fallbackDelay: isMobileFooter ? 3000 : 2000,
      })();
    }

    function ensurePlaybackAttrs() {
      video.preload = "auto";
      video.muted = true;
      video.setAttribute("autoplay", "");
      video.setAttribute("playsinline", "");
      video.removeAttribute("poster");
    }

    if (isMobileFooter) {
      var mobileSrc = video.getAttribute("data-mobile-webm");
      if (video.canPlayType && video.canPlayType("video/webm") === "") {
        mobileSrc = video.getAttribute("data-mobile-mp4");
      }
      video.querySelectorAll("source").forEach(function (source) {
        source.remove();
      });
      if (mobileSrc) {
        video.src = mobileSrc;
      }
    } else {
      var sources = video.querySelectorAll("source[data-src]");
      if (!sources.length) {
        return;
      }
      netraActivateVideoSources(video, netraPreferMp4());
    }

    ensurePlaybackAttrs();
    video.load();
    video.dataset.loaded = "true";

    if (video.readyState >= 2) {
      bootPlayback();
    } else {
      video.addEventListener("loadeddata", bootPlayback, { once: true });
      video.addEventListener(
        "canplay",
        function () {
          if (!video.paused && video.readyState >= 2) {
            showPlaying();
            return;
          }
          if (!booted) {
            bootPlayback();
          }
        },
        { once: true }
      );
    }
  }

  function observeFooterTarget(target) {
    if (!target || target.dataset.footerObserved === "true") {
      return;
    }
    target.dataset.footerObserved = "true";
    observer.observe(target);
  }

  if (!("IntersectionObserver" in window)) {
    footerVideos.forEach(loadFooterVideo);
    return;
  }

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) {
          return;
        }
        var video = entry.target.matches(".footer-video__media")
          ? entry.target.querySelector("video")
          : entry.target;
        loadFooterVideo(video);
        observer.unobserve(entry.target);
      });
    },
    { rootMargin: "200px 0px", threshold: 0.01 }
  );

  function tryPlayLoadedFooterVideo(video) {
    if (!video || video.dataset.loaded !== "true" || !video.paused) {
      return;
    }

    var section = video.closest(".footer-video");
    video.dataset.videoFailed = "";
    video.muted = true;
    video.setAttribute("playsinline", "");
    var playPromise = video.play();
    if (playPromise && typeof playPromise.then === "function") {
      playPromise
        .then(function () {
          if (section) {
            section.classList.add("is-video-ready");
          }
        })
        .catch(function () {});
    }
  }

  if (isMobileFooterViewport()) {
    footerVideos.forEach(loadFooterVideo);

    function tryPlayFooterVideosNearViewport() {
      footerVideos.forEach(function (video) {
        var rect = video.getBoundingClientRect();
        var nearViewport =
          rect.top < window.innerHeight * 1.5 && rect.bottom > -window.innerHeight * 0.25;
        if (nearViewport) {
          tryPlayLoadedFooterVideo(video);
        }
      });
    }

    var footerScrollTimer = null;
    window.addEventListener(
      "scroll",
      function () {
        if (footerScrollTimer) {
          return;
        }
        footerScrollTimer = window.requestAnimationFrame(function () {
          footerScrollTimer = null;
          tryPlayFooterVideosNearViewport();
        });
      },
      { passive: true }
    );

    tryPlayFooterVideosNearViewport();
    return;
  }

  if (footerMediaBlocks.length) {
    footerMediaBlocks.forEach(observeFooterTarget);
  } else {
    footerVideos.forEach(observeFooterTarget);
  }
})();

document.addEventListener("visibilitychange", function () {
  if (!document.hidden) {
    resumeFooterAutoplayVideos();
  }
});

window.addEventListener("pageshow", function (event) {
  if (event.persisted) {
    resumeFooterAutoplayVideos();
  }
});
